module.exports = __webpack_public_path__ + "static/img/btns.abe35af.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/btns.gif
// module id = WkO/
// module chunks = 1